import { useMutation } from '@tanstack/react-query';
import urls from '../../utils/urls';
import useNotify from '../useNotify';
import { getIntl } from '../../utils/intl';
import { appAPI } from '../../utils/api';

const intl = getIntl('useRemoveOrganizationAsCollaborator', {
    removeCollaboratorSuccess: 'Successfully removed organization as collaborator',
    removeCollaboratorFailure: 'Failed to remove organization as collaborator',
});

export type UseRemoveOrganizationAsCollaboratorArgs = {
    onRemoveOrganizationAsCollaboratorSuccess?: () => void;
};

export type RemoveOrganizationAsCollaboratorArgs = {
    organizationId: string;
    medicalProfileId: string;
};

export type UseRemoveOrganizationAsCollaboratorReturnValue = {
    removeOrganizationAsCollaborator: (args: RemoveOrganizationAsCollaboratorArgs) => void;
    isRemovingOrganizationCollaborator: boolean;
};

export const useRemoveOrganizationAsCollaborator = ({
    onRemoveOrganizationAsCollaboratorSuccess,
}: UseRemoveOrganizationAsCollaboratorArgs = {}) => {
    const notify = useNotify();

    const removeOrganizationAsCollaborator = useMutation({
        mutationFn: async (args: RemoveOrganizationAsCollaboratorArgs) => {
            return await appAPI.del(
                urls.api.organizations.profiles.profile(args.organizationId, args.medicalProfileId),
            );
        },
        onSuccess: () => {
            notify('success', intl('removeCollaboratorSuccess'));
            onRemoveOrganizationAsCollaboratorSuccess?.();
        },
        onError: () => {
            notify('error', intl('removeCollaboratorFailure'));
        },
    });

    return {
        removeOrganizationAsCollaborator: removeOrganizationAsCollaborator.mutate,
        isRemovingOrganizationCollaborator: removeOrganizationAsCollaborator.isPending,
    };
};
